import { requestJson } from '../http'
import type { KycAnswers, KycQuestionStatus, KycSuggestedAnswers } from './kyc.types'

const kycPath = (kycId: string) => `/borgo/distributor/kyc/${encodeURIComponent(kycId)}`

export const fetchKycQuestionStatus = async (kycId: string): Promise<KycQuestionStatus> =>
  await requestJson<KycQuestionStatus>(`${kycPath(kycId)}/questions`, 'GET')

/** Nothing is submitted; the values only pre-fill the form. */
export const fetchKycSuggestedAnswers = async (kycId: string): Promise<KycSuggestedAnswers> =>
  await requestJson<KycSuggestedAnswers>(`${kycPath(kycId)}/suggested-answers`, 'GET')

/**
 * Rejects with an `ApiRequestError`: 400 when an answer fails the server's rules, 404 for a KYC that isn't
 * this distributor's, 409 when the cycle no longer awaits answers.
 */
export const submitKycAnswers = async (kycId: string, answers: Partial<KycAnswers>): Promise<KycQuestionStatus> =>
  await requestJson<KycQuestionStatus>(`${kycPath(kycId)}/answers`, 'POST', { answers })
